import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { NavMarker } from 'react-rhumb';
import { SalesHubFaqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/SalesHubFaqs';
import { SalesHubProductIcon } from 'pricing-pages-ui-components/productIcon/SalesHubProductIcons';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import IntegrationsSection from '../../../components/common/IntegrationsSection';
import PhoneSupportFooter from '../../../components/common/PhoneSupportFooter';
import { BannerSection } from '../../containers/BannerSection';
import { SalesHubFeatureTable } from './SalesHubFeatureTable';
import { SalesHubMerchCards } from './SalesHubMerchCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SalesHubPage = () => {
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "SALES_HUB_PAGE",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "SALES"
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsxs(PageTitle, {
        "aria-level": 1,
        children: [/*#__PURE__*/_jsx(SalesHubProductIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.sales.pageTitle"
        })]
      }), /*#__PURE__*/_jsx(PageSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.sales.description"
        })
      })]
    }), /*#__PURE__*/_jsx(SalesHubMerchCards, {}), /*#__PURE__*/_jsx(SalesHubFeatureTable, {}), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "sales"
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "1400",
      children: /*#__PURE__*/_jsx(SalesHubFaqs, {})
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "sales-footer",
      screen: "sales",
      upgradeProduct: "sales-starter"
    })]
  });
};